var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimpleaLogoPl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 42,
    viewBox: "0 0 140 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72062 25.1416C2.72062 25.1416 5.27841 27.903 8.52707 27.903C10.5162 27.903 12.181 27.3344 12.181 26.1573C12.181 24.8983 11.2875 24.6541 8.36424 24.0457C4.54772 23.2328 1.2179 21.6091 1.2179 17.9552C1.2179 14.9502 4.22257 11.9456 9.50098 11.9456C13.8455 11.9456 16.7292 14.3004 16.7292 14.3004L14.2924 17.8735C14.2924 17.8735 12.0996 16.2092 9.50098 16.2092C7.67362 16.2092 6.00909 16.8585 6.00909 18.0356C6.00909 19.2136 7.30841 19.4977 10.5568 20.1883C14.3741 21.0002 17.0945 22.2591 17.0945 26.2382C17.0945 29.527 13.6028 32.1662 8.68888 32.1662C3.045 32.1662 0 28.6745 0 28.6745L2.72062 25.1416Z",
    fill: "#433063"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9307 31.6788H24.8028V12.4321H19.9307V31.6788Z",
    fill: "#433063"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8485 19.295V31.6792H52.9761V20.5538C52.9761 17.9146 51.9609 16.4928 49.5246 16.4928C46.9663 16.4928 45.7484 18.9694 45.7484 18.9694V31.6792H40.8755V20.5538C40.8755 17.9146 39.861 16.4928 37.4244 16.4928C34.8664 16.4928 33.6483 18.9694 33.6483 18.9694V31.6792H28.7754V12.4325H33.3236V15.2343C33.3236 15.2343 35.0696 11.9456 39.0081 11.9456C43.6367 11.9456 44.9773 15.3157 44.9773 15.3157C44.9773 15.3157 46.6008 11.9456 51.1084 11.9456C55.0064 11.9456 57.8485 14.6657 57.8485 19.295Z",
    fill: "#433063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2747 12.4323V14.9502C65.2747 14.9502 67.1021 11.9456 71.0817 11.9456C76.0758 11.9456 80.4609 16.1278 80.4609 22.0557C80.4609 27.9844 76.0758 32.1662 71.0817 32.1662C68.0359 32.1662 66.29 30.5019 65.6402 29.6898V41.0179H60.7676V12.4323H65.2747ZM65.6402 24.9389C65.6402 24.9389 67.0207 27.6182 70.229 27.6182C73.5177 27.6182 75.5069 25.223 75.5069 22.0557C75.5069 18.8893 73.5177 16.493 70.229 16.493C67.0207 16.493 65.6402 19.1733 65.6402 19.1733V24.9389Z",
    fill: "#433063"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9326 31.679H87.805V0.982178H82.9326V31.679Z",
    fill: "#433063"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.643 21.9743C109.643 22.3403 109.643 23.071 109.602 23.8017H95.2282C95.5937 25.507 97.5836 27.6996 100.628 27.6996C103.999 27.6996 105.907 25.751 105.907 25.751L108.344 29.405C108.344 29.405 105.298 32.1662 100.628 32.1662C94.7813 32.1662 90.2744 27.6996 90.2744 22.0557C90.2744 16.4116 94.3755 11.9456 99.938 11.9456C105.217 11.9456 109.643 16.0461 109.643 21.9743ZM104.771 20.2687C104.689 18.6042 103.147 16.371 99.938 16.371C96.8116 16.371 95.391 18.5636 95.2282 20.2687H104.771Z",
    fill: "#433063"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.921 12.4323V31.679H126.413V29.1618C126.413 29.1618 124.749 32.1662 120.608 32.1662C115.613 32.1662 111.228 27.9844 111.228 22.0557C111.228 16.1278 115.613 11.9456 120.608 11.9456C124.627 11.9456 126.413 14.9502 126.413 14.9502V12.4323H130.921ZM126.048 19.1733C126.048 19.1733 124.627 16.493 121.501 16.493C118.211 16.493 116.181 18.8893 116.181 22.0557C116.181 25.223 118.211 27.6182 121.501 27.6182C124.627 27.6182 126.048 24.9389 126.048 24.9389V19.1733Z",
    fill: "#433063"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.555 25.751C138.342 25.751 139.763 27.1718 139.763 28.9583C139.763 30.7451 138.342 32.1661 136.555 32.1661C134.769 32.1661 133.348 30.7451 133.348 28.9583C133.348 27.1718 134.769 25.751 136.555 25.751Z",
    fill: "#A94FE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleaLogoPl);
export default __webpack_public_path__ + "static/media/simplea-logo-pl.84d5581148ed5c822ca896cbed2952b7.svg";
export { ForwardRef as ReactComponent };